import { __decorate } from "tslib";
import Modal from "@/components/Modal.vue";
import CustomSwitch from "@/components/CustomSwitch.vue";
import MoneyField from "@/components/MoneyField.vue";
import Money from "@/components/Money.vue";
import ICDModal from '@/components/ICD10/ICDModal.vue';
import Avatar from '@/components/Avatar.vue';
import AddItemModal from '@/Pages/Appointments/AddItemModal.vue';
import ManipulationModal from '@/components/ManipulationModal.vue';
import ConfirmableButton from '@/components/ConfirmableButton.vue';
import { mapActions, mapGetters } from 'vuex';
import draggable from 'vuedraggable';
import TreatmentBrowserModal from '@/components/TreatmentBrowser.vue';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import ModalMixin from '@/mixins/modal-mixin';
let TreatmentModal = class TreatmentModal extends Mixins(ModalMixin) {
    id;
    getTreatmentFromStore;
    getProductFromStore;
    findServicesInStore;
    fetchProducts;
    fetchTreatments;
    saveNewTreament;
    patchTreatment;
    removeTreatment;
    tab = 'general';
    data = {
        serviceId: '',
        code: '',
        icd: [],
        manipulations: [],
        bundle: [],
        label: '',
        deleted: false,
    };
    staticPrice = true;
    staticDuration = true;
    errors = {};
    price = 0;
    get remindOptions() {
        return [
            { value: 1, text: this.$tc('in days', 1) },
            { value: 7, text: this.$tc('in weeks', 1) },
            { value: 14, text: this.$tc('in weeks', 2) },
            { value: 30, text: this.$tc('in months', 1) },
            { value: 60, text: this.$tc('in months', 2) },
            { value: 90, text: this.$tc('in months', 3) },
            { value: 180, text: this.$tc('in months', 6) },
            { value: 360, text: this.$tc('in months', 12) }
        ];
    }
    get reminderTreatment() {
        if (!this.data.reminder)
            return;
        return this.getTreatmentFromStore(this.data.reminder.treatmentId);
    }
    get services() {
        const data = this.findServicesInStore({ query: { $sort: { priority: 1 } } }).data;
        return data.map(item => ({ text: item.label, value: item._id }));
    }
    get fetchedBundle() {
        return this.data.bundle.map((item) => {
            if (item.type === 'product')
                return {
                    ...item,
                    product: this.getProductFromStore(item._id)
                };
            else
                return {
                    ...item,
                    service: this.getTreatmentFromStore(item._id)
                };
        });
    }
    getBundleItemQuantity(item) {
        return item.quantity;
    }
    setBundleItemQuantity(item, value) {
        item.quantity = value;
    }
    created() {
        this.fetchProducts();
        this.fetchTreatments();
    }
    shown() {
        this.tab = 'general';
        const { Treatment } = this.$FeathersVuex;
        let data = Treatment.getFromStore('temp');
        if (data) {
            delete data._id;
            this.staticPrice = true;
            this.staticDuration = true;
            this.data = this.$deepCopy(data.model);
            this.price = this.data.price ?? 0;
            this.data.reminder = this.data.reminder || undefined;
            new Treatment({
                model: {},
                _id: 'temp'
            });
        }
        this.errors = {};
    }
    hidden() {
        this.staticPrice = true;
        this.staticDuration = true;
        this.data = {
            serviceId: '',
            code: '',
            icd: [],
            manipulations: [],
            bundle: [],
            label: '',
            deleted: false,
        };
    }
    removeReminderTreatment() {
        if (this.data.reminder)
            this.data.reminder.treatmentId = '';
    }
    formatDuration(duration) {
        return this.$moment.duration(duration).humanize();
    }
    useManipulation(item) {
        if (!this.data.manipulations) {
            this.$set(this.data, 'manipulations', [item]);
        }
        else {
            this.data.manipulations.push(item);
        }
    }
    useICD(item) {
        if (!this.data.icd) {
            this.$set(this.data, 'icd', [item]);
        }
        else {
            this.data.icd.push(item);
        }
    }
    addItem(item) {
        let bundleItem;
        if ('product' in item) {
            bundleItem = {
                type: 'product',
                _id: item.product._id,
                quantity: item.quantity,
                product: item.product
            };
        }
        else {
            bundleItem = {
                type: 'service',
                _id: item.treatmentId,
                quantity: item.quantity,
                service: item.treatment
            };
        }
        if (!this.data.bundle) {
            this.$set(this.data, 'bundle', [bundleItem]);
        }
        else {
            this.data.bundle.push(bundleItem);
        }
    }
    setReminderTreatment(treatment) {
        if (this.data.reminder) {
            this.$set(this.data.reminder, 'treatmentId', treatment._id);
        }
        else {
            this.$set(this.data, 'reminder', { treatmentId: treatment._id });
        }
        this.$root.$emit('bv::hide::modal', 'SelectTreatmentModal');
    }
    removeDiangosis(index) {
        this.data.icd.splice(index, 1);
    }
    removeManipulation(index) {
        this.data.manipulations.splice(index, 1);
    }
    removeBundleItem(idx) {
        this.data.bundle.splice(idx, 1);
    }
    validation(field) {
        if (this.errors && this.errors[field])
            return false;
        else
            return null;
    }
    saveAction() {
        let promise, successMessage;
        let data = {
            ...this.data,
            price: this.price,
            manipulations: (this.data.manipulations || []).filter(manipulation => manipulation),
            bundle: (this.data.bundle || []).filter(item => (item.type === 'product' && item.product) || (item.type === 'service' && item.service)),
            icd: (this.data.icd || []).filter(item => item),
        };
        delete data._id;
        if (this.data._id) {
            promise = this.patchTreatment([this.data._id, data, {}]);
            successMessage = this.$t('Item has been saved').toString();
        }
        else {
            promise = this.saveNewTreament(data);
            successMessage = this.$t('Item has been created').toString();
        }
        promise.then(() => {
            this.$root.$emit('bv::hide::modal', this.id);
            this.$toasted.global.success({
                message: successMessage
            });
        });
        promise.catch(err => {
            this.errors = err.errors;
        });
    }
    deleteAction() {
        if (!this.data._id)
            return;
        this.removeTreatment(this.data._id);
        this.$root.$emit('bv::hide::modal', this.id);
        this.$toasted.global.success({
            message: this.$t('Item has been removed')
        });
    }
    onTabChange(tab) {
        if (tab === 'reminder') {
            if (!this.data.reminder)
                this.$set(this.data, 'reminder', {
                    active: false,
                    remindIn: 0,
                    treatmentId: '',
                });
        }
        if (tab === 'bundle') {
            if (!this.data.bundle)
                this.$set(this.data, 'bundle', []);
        }
        if (tab === 'manipulations') {
            if (!this.data.manipulations)
                this.$set(this.data, 'manipulations', []);
        }
    }
    calculateDuration() {
        if (this.staticDuration)
            return;
        this.data.duration = this.data.bundle.reduce((total, item) => {
            if (item.type !== 'service')
                return total;
            return total + (item.service?.duration ?? 0);
        }, 0);
    }
    calculatePrice() {
        if (this.staticPrice)
            return;
        this.price = this.data.bundle.reduce((total, item) => {
            if (item.type === 'product') {
                let price = (item.product?.price?.retailPrice ?? 0) / (item.product?.perServing ?? 1);
                return total + price * item.quantity;
            }
            return total + (item.service?.price ?? 0);
        }, 0);
    }
};
__decorate([
    Prop({ type: String, required: true })
], TreatmentModal.prototype, "id", void 0);
__decorate([
    Watch('tab')
], TreatmentModal.prototype, "onTabChange", null);
__decorate([
    Watch('staticDuration'),
    Watch('data.bundle', { deep: true })
], TreatmentModal.prototype, "calculateDuration", null);
__decorate([
    Watch('staticPrice'),
    Watch('data.bundle', { deep: true })
], TreatmentModal.prototype, "calculatePrice", null);
TreatmentModal = __decorate([
    Component({
        name: 'treatment-modal',
        components: {
            TreatmentBrowserModal,
            Modal,
            Avatar,
            ICDModal,
            MoneyField,
            CustomSwitch,
            AddItemModal,
            Money,
            draggable,
            ManipulationModal,
            ConfirmableButton
        },
        computed: {
            ...mapGetters('service', { findServicesInStore: 'find' }),
            ...mapGetters('products', { getProductFromStore: 'get' }),
            ...mapGetters('treatment', { getTreatmentFromStore: 'get' }),
        },
        methods: {
            ...mapActions('treatment', {
                saveNewTreament: 'create',
                patchTreatment: 'patch',
                removeTreatment: 'remove'
            }),
            ...mapActions('products', { fetchProducts: 'find' }),
            ...mapActions('treatment', { fetchTreatments: 'find' }),
        }
    })
], TreatmentModal);
export default TreatmentModal;
